import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { withRouter } from 'react-router-dom';

import {
    Page,
    LayoutSingleColumn,
    LayoutWrapperTopbar,
    LayoutWrapperMain,
    LayoutWrapperFooter,
    Footer,
} from '../../components';
import { TopbarContainer } from '../../containers';
import css from './LandingPageForClubs.css';
import {
    SectionHero,
    SectionMainBenefits,
    SectionOurMission,
    SectionOurPartners,
    SectionOurOffers,
} from '../LandingPage/sectionsForClubs';
import { SectionFactsAndNumbers } from '../LandingPage/sectionsForCompanies';
import { ensureCurrentUser } from '../../util/data';
import { getLpSchemaObj, facebookImages, twitterImages } from '../LandingPage/common/helpers';

export const LandingPageForClubs = ({
    history,
    currentUser,
    scrollingDisabled,
    currentUserRequestInProgress = true,
}) => {
    const schemaTitle = 'Unterstützung für Vereine  | HorseDeal';
    const schemaDescription =
        'Wachstum für deinen Verein und viele Mitgliedervorteile dank einer strategischen Partnerschaft. Mehr erfahren.';

    return (
        <Page
            scrollingDisabled={scrollingDisabled}
            contentType="website"
            description={schemaDescription}
            title={schemaTitle}
            facebookImages={facebookImages}
            twitterImages={twitterImages}
            schema={getLpSchemaObj(schemaTitle, schemaDescription)}
        >
            <LayoutSingleColumn>
                <LayoutWrapperTopbar>
                    <TopbarContainer />
                </LayoutWrapperTopbar>
                <LayoutWrapperMain
                    className={css.layout}
                    blobBackground
                    blobProps={{
                        xDistance: 20,
                        baseWidth: 760,
                    }}
                >
                    <main className={css.container}>
                        <SectionHero />
                        <SectionMainBenefits />
                        <SectionOurMission history={history} />
                        {!currentUserRequestInProgress && (
                            <SectionOurPartners
                                header={
                                    <header>
                                        <h2 className={css.subHeading}>Partner</h2>
                                        <p className={css.heading}>Unsere Partnerschaften</p>
                                    </header>
                                }
                            />
                        )}
                        <SectionFactsAndNumbers
                            heading={`Wir haben die Community, \num gemeinsam Grosses zu schaffen.`}
                            description="Profitiere von unserer reichweitenstarken Marke sowie loyalen Mitgliedern."
                        />
                        <SectionOurOffers />
                    </main>
                </LayoutWrapperMain>
                <LayoutWrapperFooter>
                    <Footer />
                </LayoutWrapperFooter>
            </LayoutSingleColumn>
        </Page>
    );
};

const { bool } = PropTypes;

LandingPageForClubs.propTypes = {
    scrollingDisabled: bool.isRequired,
};

const mapStateToProps = ({ user: { currentUser, currentUserRequestInProgress }, UI }) => ({
    currentUser: ensureCurrentUser(currentUser),
    scrollingDisabled: isScrollingDisabled({ UI }),
    currentUserRequestInProgress,
});

export default compose(withRouter, connect(mapStateToProps))(LandingPageForClubs);
